import { Dialog } from '@cmsgov/ds-medicare-gov';
import { useContext, useEffect, useState } from 'react';
import { createOrUnlockAccountData, getDefaultCreateOrUnlockAccountState } from '../../create-account/createAccountContext';
import { modalImpression } from '../analytics';
import Local from '../classes/local';
import '../css/dialog.css';
import translate from '../functions/translate';
import CancelButton from './CancelButton';
import H1 from './h1';
import OkButton from './OkButton';
import StackingButtons from './StackingButtons';
import { TermsAndConditions } from './TermsAndConditions';

const SecurityNoticeDialog = () => {
    const [isOpen, setIsOpen] = useState(!Local.getItem('securityNoticeAcknowledged', false));

    const headerText = translate('security_notice');
    useEffect(() => {
        if (isOpen) {
            modalImpression(headerText);
        }
    }, [isOpen, headerText]);

    const { updateData } = useContext(createOrUnlockAccountData);

    const cancel = () => {
        Local.setItem('securityNoticeAcknowledged', false);
        updateData(getDefaultCreateOrUnlockAccountState());
    };

    const ok = () => {
        Local.setItem('securityNoticeAcknowledged', true);
        setIsOpen(false);
    };

    if (!isOpen) {
        return null;
    }

    return <>
        <Dialog
            className={'security-notice'}
            getApplicationNode={() => document.getElementById('App')}
            headerClassName={'drawer-dialog-header'}
            underlayClickExits={false}
        >
            <H1>
                {headerText}
            </H1>
            <TermsAndConditions />
            <StackingButtons
                button1={<CancelButton onClick={cancel} />}
                button2={<OkButton onClick={ok} />}
            />
        </Dialog>
    </>
};

export default SecurityNoticeDialog;
